import { DocumentResponse, DocumentsResponse } from 'all-in-one-shared-api/dist/apis/documents/DocumentsResponse';

import i18n from 'i18n';

export const getAvailableClaimForms = (documentsData: DocumentsResponse | undefined): DocumentResponse[] => {
  if (!documentsData) return [];

  const items: DocumentResponse[] = [];

  const { outpatientClaimForm, inpatientClaimForm } = documentsData;

  if (outpatientClaimForm) {
    items.push({ ...outpatientClaimForm, name: i18n.t('documents.outpatientForm') });
  }
  if (inpatientClaimForm) {
    items.push({ ...inpatientClaimForm, name: i18n.t('documents.hospitalSurgicalForm') });
  }

  return items;
};
